<template>
  <div class="page-card">
    <div class="section-header">
      <div class="section-header-left">
        <div class="section-title">技师列表</div>
        <div class="search-bar">
          <input
            v-model.trim="searchWorkerId"
            class="search-input"
            placeholder="工号"
            @keyup.enter="handleSearch"
          />
          <input
            v-model.trim="searchRealName"
            class="search-input"
            placeholder="姓名"
            @keyup.enter="handleSearch"
          />
          <input
            v-model.trim="searchPhone"
            class="search-input"
            placeholder="电话"
            @keyup.enter="handleSearch"
          />
          <button
            class="search-btn search-btn-reset"
            type="button"
            @click="resetSearch"
          >
            重置
          </button>
          <button
            class="search-btn search-btn-query"
            type="button"
            :disabled="listLoading"
            @click="handleSearch"
          >
            查询
          </button>
        </div>
      </div>
      <div class="section-actions">
        <button class="add-btn" type="button" @click="openAddModal">+ 新增技师</button>
      </div>
    </div>

    <div v-if="listLoading" class="list-loading">加载中...</div>
    <template v-else>
      <table class="tech-table">
        <thead>
          <tr>
            <th class="col-worker-id">工号</th>
            <th>姓名</th>
            <th>电话</th>
            <th class="col-clinic">门诊代号</th>
            <th>服务项目</th>
            <th class="col-devices">设备</th>
            <!-- <th class="col-score">评分</th> -->
            <th class="col-orders">订单</th>
            <th class="col-action">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!rows.length">
            <td colspan="9" class="empty-cell">暂无数据</td>
          </tr>
          <tr v-for="item in rows" :key="item.id">
            <td class="cell-worker-id">{{ item.workerId }}</td>
            <td class="cell-name">{{ item.realName }}</td>
            <td>{{ item.phone }}</td>
            <td class="col-clinic">
              <div v-if="item.clinicCodes.length" class="tag-list">
                <span
                  v-for="(code, index) in item.clinicCodes"
                  :key="item.id + '-clinic-' + index"
                  class="tag tag-clinic"
                >
                  {{ code }}
                </span>
              </div>
              <span v-else class="cell-unlinked-clinic">未关联门诊</span>
            </td>
            <td>
              <div class="tag-list">
                <span
                  v-for="(tag, index) in item.serviceTags"
                  :key="item.id + '-svc-' + index"
                  class="tag tag-service"
                >
                  {{ tag }}
                </span>
                <span v-if="!item.serviceTags.length" class="cell-empty">-</span>
              </div>
            </td>
            <td class="col-devices">
              <div class="device-name-list">
                <span
                  v-for="(name, index) in item.deviceNames"
                  :key="item.id + '-dev-' + index"
                  class="device-name-text"
                >
                  {{ name }}
                </span>
                <span v-if="!item.deviceNames.length" class="cell-empty">-</span>
              </div>
            </td>
            <!-- <td class="cell-score">
              <span class="score-star">★</span>
              <span class="score-value">{{ formatScore(item.userScore) }}</span>
            </td> -->
            <td class="cell-orders">{{ formatOrderCount(item.orderCount) }}</td>
            <td class="col-action">
              <div class="action-btns">
                <button class="action-btn action-btn-edit" type="button" @click="relationHospitalRow(item)">
                  关联门诊
                </button>
                <button class="action-btn action-btn-edit" type="button" @click="editRow(item)">
                  编辑
                </button>
                <button class="action-btn action-btn-delete" type="button" @click="deleteRow(item)">
                  删除
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <el-pagination
        v-if="total > 0"
        class="tech-pagination"
        small
        layout="total, prev, pager, next"
        :current-page="pageNum"
        :page-size="pageSize"
        :total="total"
        @current-change="onPageChange"
      />
    </template>

    <!-- 新增 / 编辑技师弹框 -->
    <div
      v-if="showTechModal"
      class="modal-overlay"
      @click.self="closeTechModal"
    >
      <div class="modal modal-tech">
        <div class="modal-header">
          <span class="modal-title">{{ modalMode === 'edit' ? '编辑技师' : '新增技师' }}</span>
          <span class="modal-close" @click="closeTechModal">×</span>
        </div>
        <div class="modal-body">
          <div v-if="modalOptionsLoading" class="modal-detail-loading">加载选项中...</div>
          <template v-else>
            <div class="form-row form-row-2">
              <div class="form-group">
                <label class="form-label">工号</label>
                <input
                  v-model.trim="techForm.workerId"
                  class="form-input"
                />
              </div>
              <div class="form-group">
                <label class="form-label">姓名</label>
                <input
                  v-model.trim="techForm.realName"
                  class="form-input"
                />
              </div>
            </div>
            <div class="form-row form-row-2">
              <div class="form-group">
                <label class="form-label">电话</label>
                <input
                  v-model.trim="techForm.phone"
                  class="form-input"
                />
              </div>
              <div class="form-group">
                <label class="form-label">性别</label>
                <select v-model="techForm.sex" class="form-input form-select">
                  <option value="">-- 选择性别 --</option>
                  <option
                    v-for="opt in sexOptions"
                    :key="opt.value"
                    :value="opt.value"
                  >
                    {{ opt.label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-row form-row-region-site">
              <div class="form-group form-group-region">
                <label class="form-label">所在地区</label>
                <select v-model="techForm.region" class="form-input form-select">
                  <option value="">-- 选择地区 --</option>
                  <option
                    v-for="opt in regionOptions"
                    :key="opt.value"
                    :value="opt.value"
                  >
                    {{ opt.label }}
                  </option>
                </select>
              </div>
              <div class="form-group form-group-site">
                <label class="form-label">驻点定位</label>
                <input
                  v-model.trim="techForm.sitePositioning"
                  class="form-input"
                  placeholder="请输入驻点定位"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">可服务项目（多选）</label>
              <div v-if="!projectOptions.length" class="check-empty">暂无服务项目</div>
              <div v-else class="check-list check-list-block">
                <label
                  v-for="project in projectOptions"
                  :key="project.id"
                  class="check-item"
                >
                  <input
                    type="checkbox"
                    :value="project.id"
                    v-model="techForm.checkedProjectIds"
                  />
                  <span>{{ project.label }}</span>
                </label>
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">持有设备（多选）</label>
              <div v-if="!allDevices.length" class="check-empty">暂无设备</div>
              <div v-else class="check-list">
                <label
                  v-for="device in allDevices"
                  :key="device.deviceId"
                  class="check-item"
                >
                  <input
                    type="checkbox"
                    :value="device.deviceId"
                    v-model="techForm.checkedDeviceIds"
                  />
                  <span>{{ device.deviceName }}</span>
                </label>
              </div>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button class="footer-btn footer-btn-cancel" type="button" @click="closeTechModal">
            取消
          </button>
          <button
            class="footer-btn footer-btn-save"
            type="button"
            :disabled="savingTech || modalOptionsLoading"
            @click="saveTech"
          >
            {{ savingTech ? "保存中..." : "保存" }}
          </button>
        </div>
      </div>
    </div>

    <!-- 关联门诊弹框 -->
    <div
      v-if="showHospitalModal"
      class="modal-overlay"
      @click.self="closeHospitalModal"
    >
      <div class="modal modal-hospital">
        <div class="modal-header">
          <span class="modal-title">关联门诊</span>
          <span class="modal-close" @click="closeHospitalModal">×</span>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">门诊编号<span class="cell-unlinked-clinic">（输入完整代号可精准绑定当前医院，输入例如"CA"则绑定该代号下所有门诊）</span></label>
            <div
              v-for="(code, index) in hospitalClinicCodes"
              :key="'clinic-code-' + index"
              class="hospital-code-row"
            >
              <template v-if="editingHospitalIndex === index">
                <input
                  v-model.trim="hospitalEditDraft"
                  class="form-input hospital-code-input"
                  placeholder="请输入门诊编号"
                />
                <div class="hospital-code-actions">
                  <button
                    class="hospital-row-btn hospital-row-btn-cancel"
                    type="button"
                    @click="cancelHospitalCodeEdit"
                  >
                    取消
                  </button>
                  <button
                    class="hospital-row-btn hospital-row-btn-save"
                    type="button"
                    :disabled="savingHospital"
                    @click="saveHospitalCodeEdit(index)"
                  >
                    {{ savingHospital ? "保存中..." : "保存" }}
                  </button>
                </div>
              </template>
              <template v-else>
                <span class="hospital-code-text">{{ code }}</span>
                <div class="hospital-code-actions">
                  <button
                    class="hospital-row-btn hospital-row-btn-edit"
                    type="button"
                    :disabled="isHospitalCodeEditing || isHospitalActionLoading"
                    @click="startHospitalCodeEdit(index)"
                  >
                    修改
                  </button>
                  <button
                    class="hospital-row-btn hospital-row-btn-delete"
                    type="button"
                    :disabled="isHospitalCodeEditing || isHospitalActionLoading"
                    @click="deleteHospitalCode(index)"
                  >
                    {{ deletingHospitalCode === code ? "删除中..." : "删除" }}
                  </button>
                </div>
              </template>
            </div>

            <div
              v-if="editingHospitalIndex === 'new'"
              class="hospital-code-row"
            >
              <input
                v-model.trim="hospitalEditDraft"
                class="form-input hospital-code-input"
                placeholder="请输入门诊编号"
              />
              <div class="hospital-code-actions">
                <button
                  class="hospital-row-btn hospital-row-btn-cancel"
                  type="button"
                  @click="cancelHospitalCodeEdit"
                >
                  取消
                </button>
                <button
                  class="hospital-row-btn hospital-row-btn-save"
                  type="button"
                  :disabled="savingHospital"
                  @click="saveNewHospitalCode"
                >
                  {{ savingHospital ? "保存中..." : "保存" }}
                </button>
              </div>
            </div>

            <button
              v-if="!isHospitalCodeEditing"
              class="hospital-add-link"
              type="button"
              @click="startAddHospitalCode"
            >
              +新增门诊编号
            </button>
          </div>

          <div v-if="showHospitalPreview" class="hospital-preview-section">
            <div class="hospital-preview-header">
              <div class="hospital-preview-title">门诊信息</div>
              <div class="hospital-search-bar">
                <input
                  v-model.trim="hospitalSearchCode"
                  class="hospital-search-input"
                  placeholder="门诊编号"
                />
                <input
                  v-model.trim="hospitalSearchName"
                  class="hospital-search-input"
                  placeholder="门诊名称"
                />
                <button
                  class="hospital-search-btn hospital-search-btn-reset"
                  type="button"
                  @click="resetHospitalSearch"
                >
                  重置
                </button>
                <button
                  class="hospital-search-btn hospital-search-btn-query"
                  type="button"
                  :disabled="hospitalListLoading"
                  @click="queryHospitalList"
                >
                  查询
                </button>
              </div>
            </div>
            <div v-if="hospitalListLoading" class="hospital-list-loading">
              门诊信息加载中...
            </div>
            <template v-else>
              <table class="hospital-preview-table">
                <thead>
                  <tr>
                    <th class="col-hospital-code">门诊编号</th>
                    <th class="col-hospital-name">门诊名称</th>
                    <th class="col-address">地址</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!hospitalList.length">
                    <td colspan="3" class="hospital-list-empty">暂无门诊信息</td>
                  </tr>
                  <tr
                    v-for="(row, index) in hospitalList"
                    :key="row.hospitalCode + '-' + index"
                  >
                    <td class="col-hospital-code">{{ row.hospitalCode || "-" }}</td>
                    <td class="col-hospital-name">{{ row.hospitalName || "-" }}</td>
                    <td class="col-address">
                      <el-tooltip
                        v-if="row.address"
                        :content="row.address"
                        placement="top"
                        :open-delay="300"
                      >
                        <span class="hospital-address-text">{{ row.address }}</span>
                      </el-tooltip>
                      <span v-else class="hospital-address-text">-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <el-pagination
                v-if="hospitalListTotal > 0"
                class="hospital-pagination"
                small
                layout="total, prev, pager, next"
                :current-page="hospitalListPage"
                :page-size="hospitalListPageSize"
                :total="hospitalListTotal"
                @current-change="onHospitalPageChange"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listHospitalsByCodes } from "@/api/hospital";
import { listAllDevices, listProjectsWithDevices } from "@/api/device";
import {
  addTechnicianInfo,
  deleteTechnicianClinicCode,
  deleteTechnicianInfo,
  listTechnicians,
  relateClinicCodes,
  updateTechnicianInfo,
} from "@/api/technician";

const SUCCESS_CODE = 20000;

export default {
  name: "TechPage",
  data() {
    return {
      listLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      searchWorkerId: "",
      searchRealName: "",
      searchPhone: "",
      rows: [],
      showTechModal: false,
      showHospitalModal: false,
      relatingTech: null,
      hospitalClinicCodes: [],
      editingHospitalIndex: null,
      hospitalEditDraft: "",
      hospitalList: [],
      hospitalListTotal: 0,
      hospitalListPage: 1,
      hospitalListPageSize: 5, //5行，不然输出太多难看
      hospitalSearchCode: "",
      hospitalSearchName: "",
      hospitalQueryCode: "",
      hospitalQueryName: "",
      hospitalListLoading: false,
      savingHospital: false,
      deletingHospitalCode: "",
      modalMode: "add",
      editingChairId: null,
      savingTech: false,
      modalOptionsLoading: false,
      projectOptions: [],
      allDevices: [],
      regionOptions: [
        { value: "east", label: "华东地区" },
        { value: "south", label: "华南地区" },
        { value: "north", label: "华北地区" },
        { value: "southwest", label: "西南地区" },
      ],
      sexOptions: [
        { value: "0", label: "男" },
        { value: "1", label: "女" },
        { value: "2", label: "保密" },
      ],
      techForm: {
        workerId: "",
        realName: "",
        phone: "",
        sex: "",
        region: "",
        sitePositioning: "",
        checkedProjectIds: [],
        checkedDeviceIds: [],
      },
    };
  },
  computed: {
    showHospitalPreview() {
      return Boolean(this.relatingTech && this.relatingTech.chairId);
    },
    isHospitalCodeEditing() {
      return this.editingHospitalIndex !== null;
    },
    isHospitalActionLoading() {
      return this.savingHospital || Boolean(this.deletingHospitalCode);
    },
  },
  mounted() {
    this.fetchTechList();
  },
  methods: {
    showMessage(type, text) {
      this.$message({ message: text, type });
    },
    isBizError(res) {
      return res && res.code != null && Number(res.code) !== SUCCESS_CODE;
    },
    mapProjectCodes(projectIds) {
      if (!Array.isArray(projectIds)) return [];
      return projectIds
        .map((p) => {
          if (!p) return "";
          if (typeof p === "string") return p.trim();
          return String(p.code ?? "").trim();
        })
        .filter(Boolean);
    },
    mapDeviceNames(deviceIds) {
      if (!Array.isArray(deviceIds)) return [];
      return deviceIds
        .map((d) => {
          if (!d) return "";
          if (typeof d === "string") return d.trim();
          return String(d.deviceName ?? d.name ?? "").trim();
        })
        .filter(Boolean);
    },
    parseCodeList(raw) {
      if (raw == null || raw === "") return [];

      if (Array.isArray(raw)) {
        return raw.map((code) => String(code).trim()).filter(Boolean);
      }

      const text = String(raw).trim();
      if (!text) return [];
      if (text.includes(",")) {
        return text
          .split(",")
          .map((code) => code.trim())
          .filter(Boolean);
      }
      return [text];
    },
    mapClinicCodes(item) {
      if (!item || typeof item !== "object") return [];

      if (Array.isArray(item.clinicCodes) && item.clinicCodes.length) {
        return this.parseCodeList(item.clinicCodes);
      }

      const raw =
        item.hospitalCode ?? item.clinicCode ?? item.clinicCodes;
      return this.parseCodeList(raw);
    },
    getClinicCodesFromRow(item) {
      return this.mapClinicCodes(item);
    },
    syncRowClinicCodes() {
      if (!this.relatingTech || !this.relatingTech.chairId) return;
      const chairId = String(this.relatingTech.chairId);
      const row = this.rows.find((item) => item.chairId === chairId);
      if (row) {
        row.clinicCodes = [...this.hospitalClinicCodes];
      }
    },
    resetHospitalCodeEditState() {
      this.editingHospitalIndex = null;
      this.hospitalEditDraft = "";
    },
    startHospitalCodeEdit(index) {
      if (this.isHospitalCodeEditing) return;
      this.editingHospitalIndex = index;
      this.hospitalEditDraft = this.hospitalClinicCodes[index] || "";
    },
    startAddHospitalCode() {
      if (this.isHospitalCodeEditing) return;
      this.editingHospitalIndex = "new";
      this.hospitalEditDraft = "";
    },
    cancelHospitalCodeEdit() {
      this.resetHospitalCodeEditState();
    },
    async saveHospitalCodeEdit(index) {
      const value = String(this.hospitalEditDraft).trim();
      if (!value) {
        this.showMessage("warning", "请填写门诊编号");
        return;
      }
      const duplicate = this.hospitalClinicCodes.some(
        (code, i) => i !== index && code === value
      );
      if (duplicate) {
        this.showMessage("warning", "门诊编号已存在");
        return;
      }

      const saved = await this.saveHospitalRelation(value);
      if (!saved) return;

      this.$set(this.hospitalClinicCodes, index, value);
      this.syncRowClinicCodes();
      this.resetHospitalCodeEditState();
      this.hospitalListPage = 1;
      this.fetchHospitalList();
    },
    deleteHospitalCode(index) {
      const code = String(this.hospitalClinicCodes[index] || "").trim();
      if (!code) return;
      if (!this.relatingTech || !this.relatingTech.chairId) {
        this.showMessage("warning", "缺少 chairId，无法删除关联");
        return;
      }

      this.$confirm(`确认删除门诊编号「${code}」的关联？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => this.removeHospitalCode(index, code))
        .catch(() => {});
    },
    async removeHospitalCode(index, hospitalCode) {
      this.deletingHospitalCode = hospitalCode;
      try {
        const res = await deleteTechnicianClinicCode({
          chairId: this.relatingTech.chairId,
          hospitalCode,
        });

        if (this.isBizError(res)) {
          this.showMessage("error", res.msg || "删除门诊关联失败");
          return;
        }

        const nextCodes = this.hospitalClinicCodes.filter((_, i) => i !== index);
        this.hospitalClinicCodes = nextCodes;

        const chairId = String(this.relatingTech.chairId);
        const row = this.rows.find((item) => item.chairId === chairId);
        if (row) {
          row.clinicCodes = [...nextCodes];
        }

        this.showMessage("success", (res && res.msg) || "删除门诊关联成功");
        this.hospitalListPage = 1;
        this.fetchHospitalList();
      } catch (error) {
        const msg =
          (error && error.msg) || error.message || "删除门诊关联失败，请稍后重试";
        this.showMessage("error", msg);
      } finally {
        this.deletingHospitalCode = "";
      }
    },
    async saveNewHospitalCode() {
      const value = String(this.hospitalEditDraft).trim();
      if (!value) {
        this.showMessage("warning", "请填写门诊编号");
        return;
      }
      if (this.hospitalClinicCodes.includes(value)) {
        this.showMessage("warning", "门诊编号已存在");
        return;
      }

      const saved = await this.saveHospitalRelation(value);
      if (!saved) return;

      this.hospitalClinicCodes.push(value);
      this.syncRowClinicCodes();
      this.resetHospitalCodeEditState();
      this.hospitalListPage = 1;
      this.fetchHospitalList();
    },
    extractProjectIdList(projectIds) {
      if (!Array.isArray(projectIds)) return [];
      return projectIds
        .map((p) => String(p.id ?? p.projectId ?? "").trim())
        .filter(Boolean);
    },
    extractDeviceIdList(deviceIds) {
      if (!Array.isArray(deviceIds)) return [];
      return deviceIds
        .map((d) => String(d.deviceId ?? d.id ?? "").trim())
        .filter(Boolean);
    },
    mapTechRows(list) {
      if (!Array.isArray(list)) return [];
      return list.map((item, index) => ({
        id: String(item.userId ?? item.chairId ?? item.workerId ?? index),
        chairId: item.chairId ? String(item.chairId) : "",
        userId: item.userId ? String(item.userId) : "",
        workerId: item.workerId || "",
        realName: item.realName || "",
        phone: item.phone || "",
        sex: item.sex,
        region: item.region || "",
        sitePositioning: item.sitePositioning || "",
        checkedProjectIds: this.extractProjectIdList(item.projectIds),
        checkedDeviceIds: this.extractDeviceIdList(item.deviceIds),
        clinicCodes: this.mapClinicCodes(item),
        serviceTags: this.mapProjectCodes(item.projectIds),
        deviceNames: this.mapDeviceNames(item.deviceIds),
        orderCount: item.orderCount,
      }));
    },
    fillFormFromRow(item) {
      if (!item) return;
      const sex =
        item.sex === 0 || item.sex === 1 || item.sex === 2
          ? String(item.sex)
          : item.sex != null && item.sex !== ""
            ? String(item.sex)
            : "";
      this.techForm = {
        workerId: item.workerId || "",
        realName: item.realName || "",
        phone: item.phone || "",
        sex,
        region: item.region || "",
        sitePositioning: item.sitePositioning || "",
        checkedProjectIds: [...(item.checkedProjectIds || [])],
        checkedDeviceIds: [...(item.checkedDeviceIds || [])],
      };
    },
    formatScore(score) {
      if (score == null || score === "") return "-";
      const num = Number(score);
      return Number.isNaN(num) ? String(score) : num.toFixed(1);
    },
    formatOrderCount(count) {
      if (count == null || count === "") return "-";
      const num = Number(count);
      if (Number.isNaN(num)) return String(count);
      return `${num}单`;
    },
    resolvePagedListPayload(data) {
      if (Array.isArray(data)) {
        return { list: data, total: data.length };
      }
      if (!data || typeof data !== "object") {
        return { list: [], total: 0 };
      }
      const list = data.list || data.records || data.rows || [];
      const total = Number(data.total ?? list.length) || 0;
      return { list: Array.isArray(list) ? list : [], total };
    },
    async fetchTechList() {
      this.listLoading = true;
      try {
        const res = await listTechnicians({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          workerId: this.searchWorkerId,
          realName: this.searchRealName,
          phone: this.searchPhone,
        });
        if (this.isBizError(res)) {
          this.showMessage("error", res.msg || "列表加载失败");
          this.rows = [];
          this.total = 0;
          return;
        }
        const payload = this.resolvePagedListPayload(res && res.data);
        this.rows = this.mapTechRows(payload.list);
        this.total = payload.total;
      } catch (error) {
        const msg =
          (error && error.msg) || error.message || "列表加载失败，请稍后重试";
        this.showMessage("error", msg);
        this.rows = [];
        this.total = 0;
      } finally {
        this.listLoading = false;
      }
    },
    onPageChange(page) {
      this.pageNum = page;
      this.fetchTechList();
    },
    handleSearch() {
      this.pageNum = 1;
      this.fetchTechList();
    },
    resetSearch() {
      this.searchWorkerId = "";
      this.searchRealName = "";
      this.searchPhone = "";
      this.pageNum = 1;
      this.fetchTechList();
    },
    resetTechForm() {
      this.techForm = {
        workerId: "",
        realName: "",
        phone: "",
        sex: "",
        region: "",
        sitePositioning: "",
        checkedProjectIds: [],
        checkedDeviceIds: [],
      };
    },
    resolveListPayload(data) {
      if (Array.isArray(data)) return data;
      if (!data || typeof data !== "object") return [];
      if (Array.isArray(data.records)) return data.records;
      if (Array.isArray(data.list)) return data.list;
      return [];
    },
    normalizeDevice(device) {
      if (!device) return null;
      const deviceId = String(device.deviceId ?? device.id ?? "").trim();
      const deviceName = String(device.deviceName ?? device.name ?? "").trim();
      if (!deviceId || !deviceName) return null;
      return { deviceId, deviceName };
    },
    mapProjectOptions(list) {
      return this.resolveListPayload(list)
        .map((item) => {
          const id = String(item.id ?? item.projectId ?? "").trim();
          const code = item.code || "";
          const name = item.name || "";
          if (!id) return null;
          const label = name && code ? `${name} (${code})` : name || code;
          return { id, code, name, label };
        })
        .filter(Boolean);
    },
    async fetchModalOptions() {
      this.modalOptionsLoading = true;
      try {
        const [projectRes, deviceRes] = await Promise.all([
          listProjectsWithDevices(),
          listAllDevices(),
        ]);

        if (!this.isBizError(projectRes)) {
          this.projectOptions = this.mapProjectOptions(projectRes && projectRes.data);
        } else {
          this.projectOptions = [];
        }

        if (!this.isBizError(deviceRes)) {
          const list = this.resolveListPayload(deviceRes && deviceRes.data);
          this.allDevices = list
            .map((d) => this.normalizeDevice(d))
            .filter(Boolean);
        } else {
          this.allDevices = [];
        }
      } catch (e) {
        this.projectOptions = [];
        this.allDevices = [];
        const msg = (e && e.msg) || e.message || "选项加载失败";
        this.showMessage("error", msg);
      } finally {
        this.modalOptionsLoading = false;
      }
    },
    openAddModal() {
      this.modalMode = "add";
      this.editingChairId = null;
      this.resetTechForm();
      this.showTechModal = true;
      this.fetchModalOptions();
    },
    resetHospitalList() {
      this.hospitalList = [];
      this.hospitalListTotal = 0;
      this.hospitalListPage = 1;
      this.hospitalListLoading = false;
    },
    resetHospitalSearch() {
      this.hospitalSearchCode = "";
      this.hospitalSearchName = "";
      this.hospitalQueryCode = "";
      this.hospitalQueryName = "";
      this.hospitalListPage = 1;
      this.fetchHospitalList();
    },
    queryHospitalList() {
      this.hospitalQueryCode = this.hospitalSearchCode;
      this.hospitalQueryName = this.hospitalSearchName;
      this.hospitalListPage = 1;
      this.fetchHospitalList();
    },
    onHospitalPageChange(page) {
      this.hospitalListPage = page;
      this.fetchHospitalList();
    },
    resolveHospitalListPayload(data) {
      if (!data) {
        return { list: [], total: 0 };
      }
      if (Array.isArray(data)) {
        return { list: data, total: data.length };
      }
      const list = Array.isArray(data.list)
        ? data.list
        : Array.isArray(data.records)
          ? data.records
          : [];
      const total = Number(data.total ?? data.totalCount ?? list.length) || 0;
      return { list, total };
    },
    async fetchHospitalList() {
      if (!this.relatingTech || !this.relatingTech.chairId) {
        this.resetHospitalList();
        return;
      }

      this.hospitalListLoading = true;
      try {
        const res = await listHospitalsByCodes({
          chairId: this.relatingTech.chairId,
          hospitalCode: this.hospitalQueryCode,
          hospitalName: this.hospitalQueryName,
          pageNum: this.hospitalListPage,
          pageSize: this.hospitalListPageSize,
        });

        if (this.isBizError(res)) {
          this.resetHospitalList();
          return;
        }

        const { list, total } = this.resolveHospitalListPayload(res && res.data);
        this.hospitalList = list.map((item) => ({
          hospitalCode: item.hospitalCode || "",
          hospitalName: item.hospitalName || "",
          address: item.address || "",
        }));
        this.hospitalListTotal = total;
      } catch (error) {
        this.resetHospitalList();
      } finally {
        this.hospitalListLoading = false;
      }
    },
    relationHospitalRow(item) {
      if (!item) {
        this.showMessage("warning", "技师信息无效");
        return;
      }
      this.relatingTech = item;
      this.hospitalClinicCodes = [...this.getClinicCodesFromRow(item)];
      this.resetHospitalCodeEditState();
      this.resetHospitalList();
      this.hospitalSearchCode = "";
      this.hospitalSearchName = "";
      this.hospitalQueryCode = "";
      this.hospitalQueryName = "";
      this.showHospitalModal = true;
      this.fetchHospitalList();
    },
    closeHospitalModal() {
      this.showHospitalModal = false;
      this.relatingTech = null;
      this.hospitalClinicCodes = [];
      this.deletingHospitalCode = "";
      this.hospitalSearchCode = "";
      this.hospitalSearchName = "";
      this.hospitalQueryCode = "";
      this.hospitalQueryName = "";
      this.resetHospitalCodeEditState();
      this.resetHospitalList();
    },
    async saveHospitalRelation(hospitalCode) {
      const code = String(hospitalCode ?? "").trim();
      if (!code) {
        this.showMessage("warning", "请填写门诊编号");
        return false;
      }
      if (!this.relatingTech || !this.relatingTech.chairId) {
        this.showMessage("warning", "缺少 chairId，无法关联门诊");
        return false;
      }

      this.savingHospital = true;
      try {
        const res = await relateClinicCodes({
          chairId: this.relatingTech.chairId,
          hospitalCode: code,
        });

        if (this.isBizError(res)) {
          this.showMessage("error", res.msg || "关联门诊失败");
          return false;
        }

        this.showMessage("success", (res && res.msg) || "关联门诊保存成功");
        return true;
      } catch (error) {
        const msg =
          (error && error.msg) || error.message || "关联门诊失败，请稍后重试";
        this.showMessage("error", msg);
        return false;
      } finally {
        this.savingHospital = false;
      }
    },
    editRow(item) {
      if (!item) {
        this.showMessage("warning", "技师信息无效");
        return;
      }
      if (!item.chairId) {
        this.showMessage("warning", "缺少 chairId，无法编辑");
        return;
      }
      this.modalMode = "edit";
      this.editingChairId = String(item.chairId);
      this.fillFormFromRow(item);
      this.showTechModal = true;
      this.fetchModalOptions();
    },
    closeTechModal() {
      this.showTechModal = false;
      this.modalMode = "add";
      this.editingChairId = null;
    },
    async saveTech() {
      const isEdit = this.modalMode === "edit";
      const {
        workerId,
        realName,
        phone,
        sex,
        region,
        sitePositioning,
        checkedProjectIds,
        checkedDeviceIds,
      } = this.techForm;
      if (!workerId) {
        this.showMessage("warning", "请填写工号");
        return;
      }
      if (!realName) {
        this.showMessage("warning", "请填写姓名");
        return;
      }
      if (!phone) {
        this.showMessage("warning", "请填写电话");
        return;
      }
      if (sex === "" || sex == null) {
        this.showMessage("warning", "请选择性别");
        return;
      }
      if (!region) {
        this.showMessage("warning", "请选择所在地区");
        return;
      }

      if (isEdit && !this.editingChairId) {
        this.showMessage("warning", "缺少 chairId，无法保存");
        return;
      }

      const projectIds = (checkedProjectIds || []).map((id) => String(id));
      const deviceIds = (checkedDeviceIds || []).map((id) => String(id));
      const payload = {
        workerId,
        realName,
        phone,
        sex,
        region,
        sitePositioning: sitePositioning || "",
        projectIds,
        deviceIds,
      };

      this.savingTech = true;
      try {
        const res = isEdit
          ? await updateTechnicianInfo({
              chairId: this.editingChairId,
              ...payload,
            })
          : await addTechnicianInfo(payload);

        if (this.isBizError(res)) {
          this.showMessage(
            "error",
            res.msg || (isEdit ? "技师更新失败" : "新增技师失败")
          );
          return;
        }

        this.showMessage(
          "success",
          (res && res.msg) || (isEdit ? "技师更新成功" : "新增技师成功")
        );
        this.closeTechModal();
        if (!isEdit) {
          this.pageNum = 1;
        }
        await this.fetchTechList();
      } catch (error) {
        const msg =
          (error && error.msg) ||
          error.message ||
          (isEdit ? "技师更新失败，请稍后重试" : "新增技师失败，请稍后重试");
        this.showMessage("error", msg);
      } finally {
        this.savingTech = false;
      }
    },
    async removeTechnician(chairId) {
      try {
        const res = await deleteTechnicianInfo({ chairId });
        if (this.isBizError(res)) {
          this.showMessage("error", res.msg || "技师删除失败");
          return;
        }
        this.showMessage("success", (res && res.msg) || "技师已删除");
        if (this.rows.length === 1 && this.pageNum > 1) {
          this.pageNum -= 1;
        }
        await this.fetchTechList();
      } catch (error) {
        const msg =
          (error && error.msg) || error.message || "技师删除失败，请稍后重试";
        this.showMessage("error", msg);
      }
    },
    deleteRow(item) {
      if (!item || !item.chairId) {
        this.showMessage("warning", "缺少 chairId，无法删除");
        return;
      }

      const label = item.realName
        ? `「${item.workerId ? `${item.workerId} ` : ""}${item.realName}」`
        : "";

      this.$confirm(`确认删除技师${label}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => this.removeTechnician(item.chairId))
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.page-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 12px;
  flex-wrap: wrap;
}

.section-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
}

.section-title {
  font-size: 18px;
  color: #333;
  margin: 0;
  font-weight: 600;
  white-space: nowrap;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.search-input {
  width: 140px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
}

.search-input:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}

.search-input::placeholder {
  color: #bfbfbf;
}

.search-btn {
  height: 32px;
  padding: 0 14px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
}

.search-btn-reset {
  background: #fff;
  color: #5c6b7f;
  border: 1px solid #d9d9d9;
}

.search-btn-reset:hover {
  color: #409eff;
  border-color: #409eff;
}

.search-btn-query {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}

.search-btn-query:hover:not(:disabled) {
  background: #096dd9;
  border-color: #096dd9;
}

.search-btn-query:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.section-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tech-pagination {
  margin-top: 16px;
  text-align: right;
}

.add-btn {
  border: none;
  background: #409eff;
  color: #fff;
  border-radius: 4px;
  height: 32px;
  padding: 0 14px;
  font-size: 14px;
  cursor: pointer;
}

.add-btn:hover {
  background: #096dd9;
}

.list-loading,
.empty-cell {
  padding: 40px 0;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.tech-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  border: 1px solid #eef1f6;
}

.tech-table th,
.tech-table td {
  border-bottom: 1px solid #eef1f6;
  padding: 14px 12px;
  font-size: 14px;
  color: #3f4a5d;
  vertical-align: middle;
  text-align: left;
}

.tech-table th {
  background: #f8f9fc;
  color: #616f84;
  font-weight: 600;
}

.tech-table tbody tr:hover td {
  background: #f0f7ff;
}

.tech-table .col-worker-id {
  width: 72px;
}

.tech-table .col-clinic {
  width: 96px;
  min-width: 96px;
}

.tech-table .col-devices {
  width: 360px;
  max-width: 360px;
}

.tech-table .col-score {
  width: 80px;
  white-space: nowrap;
}

.tech-table .col-orders {
  width: 72px;
  white-space: nowrap;
}

.tech-table .col-action {
  width: 140px;
  text-align: center;
}

.cell-worker-id {
  font-weight: 700;
  color: #2f3a4c;
}

.cell-name {
  font-weight: 500;
  color: #2f3a4c;
  white-space: nowrap;
}

.cell-score {
  color: #2f3a4c;
}

.score-star {
  color: #faad14;
  margin-right: 4px;
}

.score-value {
  font-weight: 500;
}

.cell-orders {
  color: #5c6b7f;
}

.cell-empty {
  color: #bfbfbf;
}

.cell-unlinked-clinic {
  color: #bfbfbf;
  font-size: 14px;
}

.tag-list,
.device-name-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 8px;
  align-items: center;
}

.tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.5;
  white-space: nowrap;
}

.tag-clinic {
  color: #722ed1;
  background: #f9f0ff;
  border: 1px solid #d3adf7;
}

.tag-service {
  color: #1890ff;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
}

.device-name-text {
  color: #389e0d;
  font-size: 13px;
  line-height: 1.5;
  white-space: nowrap;
}

.action-btns {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.action-btn {
  border-radius: 4px;
  padding: 5px 14px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}

.action-btn-edit {
  background: #fff;
  color: #5c6b7f;
  border: 1px solid #d9d9d9;
}

.action-btn-edit:hover {
  color: #409eff;
  border-color: #409eff;
}

.action-btn-delete {
  background: #ff4d4f;
  color: #fff;
  border: 1px solid #ff4d4f;
}

.action-btn-delete:hover {
  background: #ff7875;
  border-color: #ff7875;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
}

.modal-tech,
.modal-hospital {
  width: 640px;
  max-width: calc(100% - 32px);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-hospital {
  width: 640px;
}

.hospital-preview-section {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.hospital-preview-header {
  margin-bottom: 12px;
}

.hospital-preview-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.hospital-search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.hospital-search-input {
  flex: 1;
  min-width: 120px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 13px;
  color: #333;
  background: #fff;
}

.hospital-search-input:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}

.hospital-search-btn {
  height: 32px;
  padding: 0 14px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}

.hospital-search-btn-reset {
  border: 1px solid #d9d9d9;
  background: #fff;
  color: #666;
}

.hospital-search-btn-reset:hover {
  border-color: #409eff;
  color: #409eff;
}

.hospital-search-btn-query {
  border: 1px solid #409eff;
  background: #409eff;
  color: #fff;
}

.hospital-search-btn-query:hover:not(:disabled) {
  background: #096dd9;
  border-color: #096dd9;
}

.hospital-search-btn-query:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.hospital-list-loading {
  padding: 24px 0;
  text-align: center;
  color: #999;
  font-size: 13px;
}

.hospital-preview-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 1px solid #eef1f6;
}

.hospital-preview-table .col-hospital-code {
  width: 72px;
  max-width: 72px;
}

.hospital-preview-table .col-hospital-name {
  width: auto;
  min-width: 160px;
}

.hospital-preview-table .col-address {
  width: 200px;
  max-width: 200px;
}

.hospital-address-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.hospital-preview-table th,
.hospital-preview-table td {
  border-bottom: 1px solid #eef1f6;
  padding: 10px 12px;
  font-size: 13px;
  color: #3f4a5d;
  text-align: left;
  vertical-align: middle;
}

.hospital-preview-table th {
  background: #f8f9fc;
  color: #616f84;
  font-weight: 600;
}

.hospital-preview-table tbody tr:last-child td {
  border-bottom: none;
}

.hospital-list-empty {
  text-align: center;
  color: #bfbfbf;
}

.hospital-pagination {
  margin-top: 12px;
  text-align: right;
}

.hospital-code-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.hospital-code-row:last-of-type {
  margin-bottom: 0;
}

.hospital-code-input {
  flex: 1;
  min-width: 0;
}

.hospital-code-text {
  flex: 1;
  min-width: 0;
  padding: 8px 12px;
  font-size: 14px;
  color: #333;
  background: #f8f9fc;
  border: 1px solid #eef1f6;
  border-radius: 4px;
  line-height: 1.5;
}

.hospital-code-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.hospital-row-btn {
  border-radius: 4px;
  padding: 5px 14px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  line-height: 1.5;
}

.hospital-row-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.hospital-row-btn-edit {
  border: 1px solid #409eff;
  background: #fff;
  color: #409eff;
}

.hospital-row-btn-edit:hover:not(:disabled) {
  background: #ecf5ff;
}

.hospital-row-btn-cancel {
  border: 1px solid #d9d9d9;
  background: #fff;
  color: #666;
}

.hospital-row-btn-cancel:hover {
  border-color: #409eff;
  color: #409eff;
}

.hospital-row-btn-save {
  border: 1px solid #409eff;
  background: #409eff;
  color: #fff;
}

.hospital-row-btn-save:hover {
  background: #096dd9;
  border-color: #096dd9;
}

.hospital-row-btn-delete {
  border: 1px solid #ff4d4f;
  background: #fff;
  color: #ff4d4f;
}

.hospital-row-btn-delete:hover:not(:disabled) {
  background: #fff1f0;
}

.hospital-add-link {
  display: inline-block;
  margin-top: 10px;
  padding: 0;
  border: none;
  background: none;
  color: #409eff;
  font-size: 14px;
  cursor: pointer;
  line-height: 1.5;
}

.hospital-add-link:hover {
  color: #096dd9;
}

.modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.modal-close {
  cursor: pointer;
  font-size: 20px;
  color: #999;
  line-height: 1;
}

.modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.modal-detail-loading,
.check-empty {
  font-size: 13px;
  color: #999;
  padding: 4px 0;
}

.modal-footer {
  padding: 12px 20px 16px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-shrink: 0;
}

.form-row {
  display: flex;
  gap: 16px;
}

.form-row-2 .form-group {
  flex: 1;
  min-width: 0;
}

.form-row-region-site {
  align-items: flex-start;
}

.form-group-region {
  flex: 0 0 200px;
  max-width: 200px;
  min-width: 160px;
}

.form-group-site {
  flex: 1;
  min-width: 0;
}

.form-group {
  margin-bottom: 16px;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}

.form-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  color: #333;
}

.form-input:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}

.form-select {
  appearance: auto;
  cursor: pointer;
  background: #fff;
}

.check-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
}

.check-list-block .check-item {
  flex: 0 0 100%;
  max-width: 100%;
}

.check-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  user-select: none;
}

.check-item input {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  accent-color: #409eff;
}

.footer-btn {
  min-width: 72px;
  height: 32px;
  padding: 0 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.footer-btn-cancel {
  background: #fff;
  color: #333;
  border: 1px solid #d9d9d9;
}

.footer-btn-cancel:hover {
  color: #409eff;
  border-color: #409eff;
}

.footer-btn-save {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}

.footer-btn-save:hover {
  background: #096dd9;
  border-color: #096dd9;
}

.footer-btn-save:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>
